import { deepMerge } from '../../utils/deepMerge';
import { propAdapter } from './propAdapter';
const map = {
  // '': '--st-dt-dimensions-border-radius-none', // 0px
  // '': '--st-dt-dimensions-border-radius-50', // 2px
  R100: '--st-dt-dimensions-border-radius-100',
  // 4px
  R200: '--st-legacy-dimensions-border-radius-200',
  R300: '--st-dt-dimensions-border-radius-200',
  // 8px
  // '': '--st-dt-dimensions-border-radius-300', // 12px
  R400: '--st-dt-dimensions-border-radius-400',
  // 16px
  R500: '--st-legacy-dimensions-border-radius-500',
  // 20px
  R600: '--st-legacy-dimensions-border-radius-600',
  // 22px
  R700: '--st-legacy-dimensions-border-radius-700',
  // 30px
  R800: '--st-legacy-dimensions-border-radius-800',
  // 40px
  R900: '--st-legacy-dimensions-border-radius-900',
  // 80px
  R1000: '--st-dt-dimensions-border-radius-round' // 100px
};
export const map2Tokens = legacyThemeProperty => {
  const cssVariables = Object.entries(legacyThemeProperty).reduce((cssVariables, _ref) => {
    let [legacyThemeKey, legacyThemeValue] = _ref;
    const cssVariable = legacyThemeKey !== '' ? map[legacyThemeKey] : undefined;
    return !cssVariable ? cssVariables : {
      ...cssVariables,
      [cssVariable]: typeof legacyThemeValue === 'number' ? "".concat(legacyThemeValue, "px") : legacyThemeValue
    };
  }, {});
  return cssVariables;
};
export const map2LegacyTheme = (tokens, legacyThemeProperty) => {
  const legacyThemeObject = Object.entries(legacyThemeProperty).reduce((legacyThemeObject, _ref2) => {
    let [legacyThemeKey] = _ref2;
    const cssVariable = legacyThemeKey !== '' ? map[legacyThemeKey] : undefined;
    const tokenValue = cssVariable && tokens[':root'] ? tokens[':root'][cssVariable] : undefined;
    return !cssVariable && !tokenValue ? legacyThemeObject : {
      ...legacyThemeObject,
      [legacyThemeKey]: typeof tokenValue === 'string' ? parseInt(tokenValue.replace('px', '')) : tokenValue
    };
  }, {});
  return deepMerge({}, legacyThemeProperty, legacyThemeObject);
};
export const radiusPropAdapter = propAdapter(map);